import { useState } from "react";
import { useLocale } from "@shared/client/locale";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/components/ui/tooltip";
import { fullDate, parseDate, relativeTime } from "@shared/lib/relative-time";

/**
 * Une date dite par sa fraîcheur (« hier », « il y a 3 semaines ») ; la date
 * exacte au survol. Une valeur qui n'est pas une date (« printemps 2026 »)
 * s'affiche telle quelle.
 */
export function RelativeTime({ value, className }: { value: string | null | undefined; className?: string }) {
  // L'horloge est figée au montage : lire Date.now() pendant le rendu le rendrait instable.
  const [now] = useState(() => Date.now());
  const locale = useLocale();
  const parsed = parseDate(value);
  if (!value) return null;
  if (!parsed) return <span className={className}>{value}</span>;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <time className={className} dateTime={value}>
          {relativeTime(parsed.time, now, parsed.dayOnly, locale)}
        </time>
      </TooltipTrigger>
      <TooltipContent className="first-letter:uppercase">{fullDate(parsed.time, parsed.dayOnly, locale)}</TooltipContent>
    </Tooltip>
  );
}
